


<div class="container">
  <div class="Picture">
      <img src={{photoUrl}} height="100%" width="100%">
  </div>
  <div class="Information">
    <div class="Name">{{name}} - {{AXID}}</div>
    <div class="Details">{{company}} | {{department}} | {{team}} | {{title}} | {{employmentStatus}} | {{employeeType}}</div>
    <div class="PhoneEmail"><a href={{phoneLink}}><i class="fas fa-phone-alt" *ngIf="hasPhone"></i></a> {{phoneNumber}}  &nbsp;&nbsp;&nbsp;&nbsp; <a href={{cellLink}}><i class="fas fa-mobile-alt" *ngIf="hasCell"></i></a> {{cellNumber}}  &nbsp;&nbsp;&nbsp;&nbsp; <a href={{emailLink}}><i class="far fa-envelope"></i></a> {{emailAddress}}</div>
    <div class="Address"><a href={{addressLink}}><i class="fas fa-exclamation-triangle"></i></a> Address: &nbsp;&nbsp; {{cityStateZip}}</div>
  </div>
  <div class="WorkStatus">
    <div class="WorkStatusText">WORK STATUS:</div>
    <!-- <div>Active</div> -->
    <div class="WorkStatusDdl"><dw-search-select-lookup [lookupId]="LookupId" [(ngModel)]="selectedId" (ngModelChange)="modelChangeFn($event)"></dw-search-select-lookup></div>
  </div>
  <div class="YearsService">
    <div class="YearsServiceNumber">{{yrsService}}</div>
    <div class="YearsServiceText" *ngIf="isWachterEmployee">Years of Service</div>
  </div>
</div>
